import { useEffect } from 'react';

export default function CredstonePrivacyPolicy() {
  useEffect(() => {
    // Analytics would be implemented here if needed
    // For now, just scroll to top
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
      backgroundColor: '#ffffff',
      color: '#333333',
      lineHeight: '1.6',
      fontSize: '16px'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '40px 20px',
        textAlign: 'center',
        borderBottom: '1px solid #e9ecef'
      }}>
        <img
          src="/apps/credstone/logo.png"
          alt="c r e d s t o n e"
          style={{
            width: '64px',
            height: '64px',
            marginBottom: '20px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        />
        <h1 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a1a',
          margin: '0 0 8px 0'
        }}>
          Privacy Policy
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#db0474',
          margin: '0 0 8px 0',
          fontWeight: '500'
        }}>
          c r e d s t o n e
        </p>
        <p style={{
          fontSize: '14px',
          color: '#666666',
          margin: '0'
        }}>
          Effective Date: July 12, 2025
        </p>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '720px',
        margin: '0 auto',
        padding: '32px 20px'
      }}>
        
        {/* Introduction */}
        <div style={{
          marginBottom: '32px',
          padding: '24px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          <p style={{
            fontSize: '16px',
            color: '#495057',
            margin: '0',
            fontWeight: '400'
          }}>
            Thank you for choosing <strong style={{ color: '#1a1a1a' }}>c r e d s t o n e</strong>. 
            This Privacy Policy explains how we collect, use, and safeguard your personal information 
            when you use our credit card milestone tracking application. We are committed to protecting 
            your privacy while providing you with valuable insights into your credit card usage and rewards.
          </p>
        </div>

        {/* Important Notice */}
        <div style={{
          marginBottom: '32px',
          padding: '20px',
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          border: '1px solid #ffeaa7'
        }}>
          <h3 style={{
            fontSize: '1.1rem',
            fontWeight: '600',
            color: '#856404',
            margin: '0 0 12px 0'
          }}>
            Important Notice About SMS Access
          </h3>
          <p style={{
            fontSize: '14px',
            color: '#856404',
            margin: '0'
          }}>
            c r e d s t o n e requires SMS reading permissions to analyze your transaction messages from banks 
            and credit card issuers. We <strong>only read SMS messages from financial institutions</strong> 
            and never access your personal messages, OTPs, or other sensitive communications.
          </p>
        </div>

        {/* Section 1 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Information We Collect
          </h2>
          <div style={{ paddingLeft: '0' }}>
            <div style={{ marginBottom: '20px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>SMS Transaction Data:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                We read SMS messages from banks and credit card issuers to identify your credit cards, 
                track spending patterns, and calculate milestone progress. We do not read personal messages, 
                OTPs, or communications from non-financial entities.
              </span>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Account Information:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                When you sign in with Google or create an account, we collect your name, email address, 
                and profile picture for authentication and personalization.
              </span>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Credit Card Information:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                Card numbers (last 4 digits only), issuing bank, card type, and associated reward programs 
                extracted from transaction SMS messages.
              </span>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Transaction Data:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                Transaction amounts, merchant categories, dates, and spending patterns to calculate 
                milestone progress and provide spending insights.
              </span>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Device Information:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                Device model, operating system version, app version, and unique device identifiers 
                for security and performance optimization.
              </span>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <strong style={{ color: '#1a1a1a', fontSize: '15px' }}>Usage Analytics:</strong>
              <span style={{ color: '#495057', marginLeft: '4px' }}>
                App usage patterns, feature interactions, and performance metrics to improve our services.
              </span>
            </div>
          </div>
        </div>

        {/* Section 2 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            How We Use Your Information
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '12px' }}>• <strong>Credit Card Discovery:</strong> Identify all your credit cards from transaction SMS messages</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Milestone Tracking:</strong> Calculate progress toward spending milestones and reward thresholds</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Spending Analytics:</strong> Provide insights into spending patterns and category-wise breakdowns</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Personalized Recommendations:</strong> Suggest optimal card usage for maximum rewards</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Account Management:</strong> Authenticate users and maintain secure access to their data</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Service Improvement:</strong> Analyze usage patterns to enhance app functionality and user experience</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Security Monitoring:</strong> Detect unusual patterns that might indicate fraudulent activity</div>
          </div>
        </div>

        {/* Section 3 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            SMS Processing and Security
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Selective SMS Reading:</strong> We employ advanced 
              filtering to read only SMS messages from recognized financial institutions including banks, 
              credit card issuers, and payment processors.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Local Processing:</strong> SMS analysis happens 
              locally on your device when possible, minimizing data transmission.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Data Encryption:</strong> All SMS data is encrypted 
              both in transit and at rest using industry-standard encryption protocols.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>No Personal Messages:</strong> We never access 
              personal messages, OTPs, promotional content, or any non-transaction related SMS.
            </div>
          </div>
        </div>

        {/* Section 4 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Data Storage and Security
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Encryption:</strong> All data is encrypted using 
              AES-256 encryption standards both in transit and at rest.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Data Masking:</strong> Sensitive information like 
              full credit card numbers is masked, storing only the last 4 digits for identification.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Secure Servers:</strong> Data is stored on secure 
              servers in India, complying with local data residency requirements.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Access Controls:</strong> Strict access controls 
              ensure only authorized personnel can access your data for legitimate purposes.
            </div>
          </div>
        </div>

        {/* Section 5 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Third-Party Services
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Google Sign-In:</strong> For secure authentication 
              and basic profile information access.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Firebase Analytics:</strong> For app performance 
              monitoring and usage analytics (anonymized data only).
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Cloud Storage:</strong> Encrypted data storage 
              on secure cloud infrastructure within India.
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#1a1a1a' }}>Notification Services:</strong> For sending 
              milestone alerts and important updates.
            </div>
          </div>
        </div>

        {/* Section 6 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Data Sharing and Disclosure
          </h2>
          <div style={{ color: '#495057' }}>
            <p style={{ marginBottom: '16px' }}>
              We do not sell, rent, or share your personal information with third parties for marketing 
              purposes. We may share anonymized, aggregated data for research and industry insights.
            </p>
            <div style={{ marginBottom: '12px' }}>
              <strong style={{ color: '#1a1a1a' }}>Legal Compliance:</strong> We may disclose information 
              when required by law or to protect our rights and safety.
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong style={{ color: '#1a1a1a' }}>Service Providers:</strong> We may share data with 
              trusted service providers who assist in app functionality, under strict confidentiality agreements.
            </div>
          </div>
        </div>

        {/* Section 7 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Data Retention and Deletion
          </h2>
          <div style={{ color: '#495057' }}>
            <p style={{ marginBottom: '16px' }}>
              We retain your data only as long as necessary to provide our services and comply with 
              legal obligations. You can request data deletion at any time.
            </p>
            <div style={{ marginBottom: '12px' }}>• Transaction data: Retained for up to 24 months for milestone tracking</div>
            <div style={{ marginBottom: '12px' }}>• Account information: Retained while your account is active</div>
            <div style={{ marginBottom: '12px' }}>• Analytics data: Anonymized and retained for service improvement</div>
            <div style={{ marginBottom: '12px' }}>• SMS data: Processed locally when possible, minimal server storage</div>
          </div>
        </div>

        {/* Section 8 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Your Rights and Controls
          </h2>
          <div style={{ color: '#495057' }}>
            <div style={{ marginBottom: '12px' }}>• <strong>Access:</strong> Request access to your personal data</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Rectification:</strong> Correct inaccurate information</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Erasure:</strong> Request deletion of your data</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Portability:</strong> Export your data in a structured format</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Restrict Processing:</strong> Limit how we use your data</div>
            <div style={{ marginBottom: '12px' }}>• <strong>Withdraw Consent:</strong> Revoke SMS permissions through app settings</div>
          </div>
        </div>

        {/* Section 9 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Compliance and Regulations
          </h2>
          <div style={{ color: '#495057' }}>
            <p style={{ marginBottom: '16px' }}>
              c r e d s t o n e complies with applicable Indian data protection laws and RBI guidelines 
              for financial technology applications.
            </p>
            <div style={{ marginBottom: '12px' }}>
              • Personal Data Protection Bill (PDPB) compliance
            </div>
            <div style={{ marginBottom: '12px' }}>
              • RBI guidelines for digital financial services
            </div>
            <div style={{ marginBottom: '12px' }}>
              • Information Technology Act, 2000 and rules
            </div>
            <div style={{ marginBottom: '12px' }}>
              • Data localization requirements for financial data
            </div>
          </div>
        </div>

        {/* Section 10 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Children's Privacy
          </h2>
          <p style={{ color: '#495057', margin: '0' }}>
            c r e d s t o n e is not intended for users under 18 years of age. We do not knowingly collect 
            personal information from children under 18. If we discover that we have collected such 
            information, we will delete it immediately.
          </p>
        </div>

        {/* Section 11 */}
        <div style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e9ecef'
          }}>
            Updates to This Policy
          </h2>
          <p style={{ color: '#495057', margin: '0' }}>
            We may update this Privacy Policy periodically to reflect changes in our practices or 
            legal requirements. We will notify you of significant changes through the app or via 
            email. Your continued use of c r e d s t o n e after such changes constitutes acceptance of 
            the updated policy.
          </p>
        </div>

        {/* Contact Section */}
        <div style={{
          padding: '24px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef',
          marginBottom: '32px'
        }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1a1a1a',
            margin: '0 0 16px 0'
          }}>
            Contact Us
          </h2>
          <p style={{ color: '#495057', margin: '0 0 16px 0' }}>
            If you have any questions about this Privacy Policy, want to exercise your rights, 
            or request data deletion, please contact us:
          </p>
          <div style={{ marginBottom: '12px' }}>
            <strong style={{ color: '#1a1a1a' }}>Email:</strong>
            <a 
              href="mailto:support@tattvadynamics.com" 
              style={{
                color: '#db0474',
                textDecoration: 'none',
                marginLeft: '8px',
                fontWeight: '500'
              }}
            >
              support@tattvadynamics.com
            </a>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong style={{ color: '#1a1a1a' }}>Data Protection Officer:</strong>
            <a 
              href="mailto:support@tattvadynamics.com" 
              style={{
                color: '#db0474',
                textDecoration: 'none',
                marginLeft: '8px',
                fontWeight: '500'
              }}
            >
              support@tattvadynamics.com
            </a>
          </div>
          <div>
            <strong style={{ color: '#1a1a1a' }}>Response Time:</strong>
            <span style={{ color: '#495057', marginLeft: '8px' }}>
              We will respond to your inquiries within 30 days as required by law.
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        textAlign: 'center',
        padding: '24px 20px',
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e9ecef',
        color: '#6c757d',
        fontSize: '14px'
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          © 2025 c r e d s t o n e. All rights reserved.
        </p>
        <p style={{ margin: '0', fontSize: '12px' }}>
          Last updated: July 12, 2025 | Version 1.0
        </p>
      </div>
    </div>
  );
}